import subscribeToPlaybackApiResponse from './Subscribers/subscribeToPlaybackApiResponse';

const connectPlaybackSubscriptions = middleware => [
    subscribeToPlaybackApiResponse(
        middleware.apiServices.playback.response$,
        middleware.state.stores.playback,
        middleware.state.stores.precision,
    ),
];

export default connectPlaybackSubscriptions;
